const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
const TOKEN_URL = `${API_BASE_URL}/api/token/`;
const TOKEN_REFRESH_URL = `${API_BASE_URL}/api/token/refresh/`;

interface ILoginResponse {
  access: string;
  refresh: string;
  user_id: number;
  is_restaurant: boolean;
}

interface IRefreshAccessTokenResponse {
  access: string;
  refresh?: string;
}

export const login = async (username: string, password: string) => {
  const response = await fetch(TOKEN_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ username, password }),
  });

  if (!response.ok) {
    throw new Error('Could not sign in.');
  }

  return response.json() as Promise<ILoginResponse>;
};

export const refreshAccessToken = async (refreshToken: string) => {
  const response = await fetch(TOKEN_REFRESH_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ refresh: refreshToken }),
  });

  if (!response.ok) {
    throw new Error('Could not refresh session.');
  }

  return response.json() as Promise<IRefreshAccessTokenResponse>;
};

export type { ILoginResponse, IRefreshAccessTokenResponse };
